export { BarcodeScanInput } from './BarcodeScanInput';
export type { BarcodeScanInputProps } from './BarcodeScanInput';
